export function isDataUrl(url) {
    return url.startsWith("data:");
}
export function dataUrlToFile(url, fileName) {
    const arr = url.split(",");
    const mimeParts = arr[0].match(/:(.*?);/);
    if (!mimeParts || mimeParts.length < 2)
        return null;
    const mime = mimeParts[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
}
